import React from 'react';
import { getCredentialingDepositSummary, getPracticeCredentialingDepositSummary } from 'api/financials';
import { TCredentialingDepositSummary } from 'types/financials';

const globalData: Partial<Record<'my' | 'practice', TCredentialingDepositSummary>> = {};

const useCredentialingDepositSummary = (
    timeRangeMonths?: number,
    isPractice = false,
): [TCredentialingDepositSummary | undefined, boolean, () => void] => {
    const scope = isPractice ? 'practice' : 'my';
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<TCredentialingDepositSummary | undefined>(globalData[scope]);
    const fetchData = async () => {
        try {
            setLoading(true);
            const request = isPractice ? getPracticeCredentialingDepositSummary : getCredentialingDepositSummary;
            const result = await request(timeRangeMonths || 0);
            if (!result.error) {
                const data: TCredentialingDepositSummary = result?.data?.data;
                globalData[scope] = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (timeRangeMonths !== undefined) {
            fetchData();
        }
    }, [timeRangeMonths, isPractice]);

    return [items, loading, fetchData];
};

export default useCredentialingDepositSummary;
